<template>
  <Layout v-loading="isLoading">
    <template #top>
      <h1>{{ title }}</h1>
    </template>
    <template>
      <Body
        ref="table"
        :headConfig="tableData.headConfig"
        :tableData="data.interactionList"
        @sort-change="sortDate"
      />
    </template>
    <template #bottom>
      <Foot :total="data.total" @get-data="getPage" />
    </template>
  </Layout>
</template>

<script>
import Layout from "@/components/Layout";
import Head from "@/components/Table/Head";
import Body from "@/components/Table/Body";
import Foot from "@/components/Table/Foot";
import requstData from "@/mixins/requstData.js";
import getInteractionByPageId from "@/api/getInteractionByPageId.js";
export default {
  mixins: [requstData({ interactionList: [], total: 10 }, true)],
  components: {
    Layout,
    Head,
    Body,
    Foot,
  },
  data() {
    return {
      order: "asc",
      title: "",
      tableData: {
        headConfig: {
          select: true,
          selectProp: "createTime",
          defaultSort: { prop: "sendTime", order: "ascending" },
          key: "sendId",
          list: [
            { label: "详情", width: "65", type: "expand" },
            { label: "贴文信息", prop: "content" },
            { label: "留言信息", prop: "leaveMessage" },
            { label: "类型", prop: "sendType", width: "80" },

            { label: "帖子展示次数", prop: "postImpressions", width: "120" },
            {
              label: "帖子覆盖人数",
              prop: "postImpressionsUnique",
              width: "120",
            },
            { label: "心情数量", prop: "like", width: "95" },
            { label: "评论数量", prop: "comments", width: "95" },
            { label: "照片浏览量", prop: "photoView", width: "95" },
            { label: "分享次数", prop: "shares", width: "95" },
            { label: "其他点击量", prop: "otherClicks", width: "95" },
            {
              label: "排文时间",
              prop: "sendTime",
              width: "180",
              sortable: "custom",
            },
          ],
        },
      },
    };
  },
  mounted() {
    const { pageName } = this.$route.query;
    this.title = pageName ? pageName : "";
  },
  methods: {
    async requst(params) {
      const { id } = this.$route.params;
      if (id) {
        return await getInteractionByPageId({
          ...params,
          ...{ pageId: id, order: this.order },
        });
      }
    },
    sortDate(data) {
      const { order } = data;
      this.order = order == "descending" ? "desc" : "asc";
      this.getData();
    },
  },
};
</script>

<style></style>
